import NationalResult from '../models/NationalResult'
import {
  BASE_ELECTION_KEY,
  BYELECTIONS_KEY,
  ELECTION_2019_KEY
} from './DataController'

// With a resultKey, we will strip off anything after a hash mark
export const processResultKey = (resultKey: string): string => {
  const indexOfHash = resultKey.indexOf('#')
  if (indexOfHash > -1) {
    resultKey = resultKey.substring(0, indexOfHash)
  }
  return resultKey
}

export const compareResultKeys = (
  resultKeyA: string,
  resultKeyB: string
): boolean => {
  const strippedKeyA = processResultKey(resultKeyA)
  const strippedKeyB = processResultKey(resultKeyB)

  return strippedKeyA === strippedKeyB
}

export default class ElectionResultStore {
  protected store: { [electionKey: string]: NationalResult }

  public constructor() {
    this.store = {}
  }

  public add(resultKey: string, nationalResult: NationalResult): void {
    // With a resultKey, we will strip off anything after a hash mark
    resultKey = processResultKey(resultKey)
    this.store[resultKey] = nationalResult
  }

  public reset(): void {
    Object.keys(this.store).forEach((key: string): void => {
      if (
        key !== BASE_ELECTION_KEY &&
        key !== BYELECTIONS_KEY &&
        key !== ELECTION_2019_KEY
      ) {
        delete this.store[key]
      }
    })
  }

  public resultsForKey(resultKey: string): NationalResult {
    resultKey = processResultKey(resultKey)
    return this.store[resultKey]
  }
}
